import styled, { keyframes } from "styled-components/macro";

export const TableElement = styled.table`
  width: 100%;
  display: table;
  border-spacing: 0;
  border-collapse: separate;
`;

export const Td = styled.td`
  display: table-cell;
  padding: 16px;
  font-size: 0.875rem;
  text-align: left;
  font-weight: 400;
  line-height: 1.43;
  min-width: ${(props) => (props.left ? "max(180px, 40px)" : "inherit")};
  z-index: ${(props) => (props.left || props.right ? 50 : "inherit")};
  position: ${(props) => (props.left || props.right ? "sticky" : "inherit")};
  left: ${(props) => (props.left ? props.left : "auto")};
  right: ${(props) => (props.right ? props.right : "auto")};
  border-bottom: 1px solid rgba(224, 224, 224, 1);
  letter-spacing: 0.01071em;
  vertical-align: inherit;
  color: rgba(0, 0, 0, 0.87);
  box-shadow: ${(props) =>
    props.left
      ? props.isLast
        ? "rgb(0 0 0 / 10%) -4px 0px 8px -6px inset"
        : "none"
      : props.right
      ? "rgb(0 0 0 / 10%) 4px 0px 8px 6px"
      : "none"};
  clip-path: ${(props) => (props.right ? "inset(0px 0px 0px -350px)" : "none")};
  background-color: ${(props) =>
    props.left ? (props.isOdd ? "#ffffff" : "#f2f2f2") : "inherit"};

  & > div {
    min-width: 0;
    white-space: normal;
    text-align: left;
  }
`;

export const TdExpand = styled.td`
  display: table-cell;

  font-size: 0.875rem;
  text-align: left;
  font-weight: 400;
  line-height: 1.43;

  letter-spacing: 0.01071em;
  vertical-align: inherit;
  color: rgba(0, 0, 0, 0.87);
  & > div {
    min-width: 0;
    white-space: normal;
    text-align: left;
  }
`;
export const Th = styled.th`
  display: table-cell;
  padding: 16px;
  font-size: 0.875rem;
  text-align: left;
  letter-spacing: 0.01071em;
  vertical-align: inherit;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
  line-height: 1.5rem;
  & > div > div {
    min-width: 0;
    white-space: normal;
    text-align: left;
  }
  &:hover {
    border-right: 1px solid #ccc;
  }
  border-bottom: 1px solid #ccc;
`;

export const ThSticky = styled.th`
  display: table-cell;
  padding: 16px;
  font-size: 0.875rem;
  text-align: left;
  letter-spacing: 0.01071em;
  vertical-align: inherit;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
  line-height: 1.5rem;
  min-width: ${(props) => (props.left ? "max(180px, 40px)" : "inherit")};
  position: sticky;
  left: ${(props) => (props.left ? props.left : "auto")};
  right: ${(props) => (props.right ? props.right : "auto")};
  z-index: 40;
  background-color: #ffffff;
  box-shadow: ${(props) =>
    props.left
      ? props.isLast
        ? "rgb(0 0 0 / 10%) -4px 0px 8px -6px inset"
        : "none"
      : props.right
      ? "rgb(0 0 0 / 10%) 4px 0px 8px 6px"
      : "none"};
  clip-path: ${(props) =>
    props.right ? "inset(-1px 0px 0px -350px)" : "none"};
  & > div > div {
    min-width: 0;
    white-space: normal;
    text-align: left;
  }

  &:hover {
    border-right: 1px solid #ccc;
  }
  border-bottom: 1px solid #ccc;
`;

export const Tr = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
  &:nth-child(odd) {
    background-color: #ffffff;
  }

  color: inherit;
  display: table-row;
  outline: 0;
  vertical-align: middle;
`;

export const TrSub = styled.tr`
  color: inherit;
  display: table-row;
  outline: 0;
  vertical-align: middle;
`;

export const TBody = styled.tbody`
  /* position: relative;
  display: block;
  height: ${(props) =>
    props.tableBodyHeight ? props.tableBodyHeight + `rem` : "auto"};
  overflow: scroll; */
  display: table-row-group;
`;

export const Thead = styled.thead`
  display: table-header-group;
  position: sticky;
  inset-block-start: 0;
  z-index: 99;
`;

export const PageButton = styled.button`
  border: 0;
  background: 0;
  font-family: "Source Sans Pro Semibold";
  font-size: 1.1rem;
  cursor: pointer;
  padding: 0.5rem;
  padding-bottom: 0.2rem;
  &:hover {
    background: #f2f2f2;
  }
`;

export const ActionsIcon = styled.button`
  cursor: pointer;
  font-size: 1.3rem;
  border: 0;
  background: 0;
  padding: 0;
`;

export const TableLoading = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  background: rgba(255, 255, 255, 0.7);
`;

export const Resizer = styled.div`
  right: 0;
  width: 10px;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
  touch-action: none;

  &.isResizing {
  }
`;

export const InLineTitlePin = styled.div`
  display: flex;
  align-items: center;
  word-break: break-word;
`;

// --- Standardized pagination bar (AC-15379) ---------------------------------

const shakeAnimation = keyframes`
  0%, 100% { transform: translateX(0); }
  20%, 60% { transform: translateX(-4px); }
  40%, 80% { transform: translateX(4px); }
`;

// Full-width bar with a single top border separating it from the table rows.
export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-top: 1px solid rgba(224, 224, 224, 1);
  padding: 0.5rem 0;
`;

// Record range "X–Y of Z" — sits on the far left.
export const RecordCount = styled.span`
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
`;

// Right-aligned group holding per-page, page indicator and arrows.
export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;
`;

export const PaginationGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.875rem;
  white-space: nowrap;
`;

export const PageSizeSelect = styled.select`
  border: 1px solid ${(props) => props.theme.fieldBorder};
  border-radius: 4px;
  padding: 0.2rem 0.4rem;
  font-size: 0.875rem;
  background: ${(props) => props.theme.surface};
  color: ${(props) => props.theme.onSurface};
  cursor: pointer;
  &:hover {
    border-color: ${(props) => props.theme.onSurface};
  }
  &:focus {
    border-color: ${(props) => props.theme.onSecondarySurface};
    outline: none;
  }
`;

// Inline, visually-boxed editable jump-to-page input. Hover darkens the
// border; focus turns it blue with a ring; an out-of-range entry briefly
// shakes red (set data-shake="true").
export const JumpToPageInput = styled.input`
  /* Grows with the digit count so large page numbers (10000+) aren't clipped. */
  width: auto;
  min-width: 3.5ch;
  field-sizing: content;
  text-align: center;
  border: 1px solid ${(props) => props.theme.fieldBorder};
  border-radius: 4px;
  padding: 0.15rem 0.25rem;
  font-size: 0.875rem;
  color: ${(props) => props.theme.onSurface};
  background: ${(props) => props.theme.surface};
  transition: border-color 150ms linear, box-shadow 150ms linear;
  -moz-appearance: textfield;

  &:hover {
    border-color: ${(props) => props.theme.onSurface};
  }
  &:focus {
    border-color: ${(props) => props.theme.onSecondarySurface};
    box-shadow: 0 0 0 2px rgba(0, 159, 212, 0.25);
    outline: none;
  }
  &[data-shake="true"] {
    border-color: ${(props) => props.theme.danger};
    animation: ${shakeAnimation} 0.4s linear;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

// Lightly-bordered prev/next arrow buttons; disabled at the boundaries.
export const ArrowButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(props) => props.theme.fieldBorder};
  border-radius: 4px;
  background: ${(props) => props.theme.surface};
  cursor: pointer;
  padding: 0.15rem;
  font-size: 1.1rem;
  line-height: 1;
  color: ${(props) => props.theme.onSurface};
  transition: background 150ms linear, border-color 150ms linear;

  &:hover:not(:disabled) {
    background: #f2f2f2;
    border-color: ${(props) => props.theme.onSurface};
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
